// Get address from coordinates using Google Places API
export const getAddressFromCoordinates = async (location, placesService) => {
  return new Promise((resolve) => {
    const request = {
      location: location,
      radius: 50
    };

    placesService.nearbySearch(request, (results, status) => {
      if (status === window.google.maps.places.PlacesServiceStatus.OK && results && results.length > 0) {
        const placesWithStreet = results.filter(place =>
          place.vicinity &&
          /\d/.test(place.vicinity) &&
          !place.vicinity.includes("Stockholm, Sverige")
        );

        if (placesWithStreet.length > 0) {
          resolve(placesWithStreet[0].vicinity);
        } else if (results[0].vicinity && results[0].vicinity !== "Stockholm, Sverige") {
          resolve(results[0].vicinity);
        } else {
          tryTextSearch();
        }
      } else {
        tryTextSearch();
      }
    });

    function tryTextSearch() {
      const lat = typeof location.lat === 'function' ? location.lat() : location.lat;
      const lng = typeof location.lng === 'function' ? location.lng() : location.lng;

      const textRequest = {
        location: location,
        radius: 100,
        query: `address ${lat.toFixed(5)} ${lng.toFixed(5)}`
      };

      placesService.textSearch(textRequest, (textResults, textStatus) => {
        if (textStatus === window.google.maps.places.PlacesServiceStatus.OK &&
            textResults && textResults.length > 0) {
          if (textResults[0].formatted_address &&
              textResults[0].formatted_address !== "Stockholm, Sverige") {
            resolve(textResults[0].formatted_address);
          } else if (textResults[0].name) {
            resolve(textResults[0].name);
          } else {
            resolve(`Position (${lat.toFixed(5)}, ${lng.toFixed(5)})`);
          }
        } else {
          resolve(`Position (${lat.toFixed(5)}, ${lng.toFixed(5)})`);
        }
      });
    }
  });
};
